module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-nhs-a9a7aa99f35dc2bc933596c5534e0179.png";